import React, { useEffect } from "react";
import { ListGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getTopCurrencies } from "../../redux/actions.portfolio";
import HeaderModal from "./Modal/HeaderModal";
import styles from "./Header.module.scss";

const Header = () => {
  const dispatch = useDispatch();
  const { TOPCurrencies } = useSelector((state) => state.portfolio);

  const currenciesToRender = TOPCurrencies.map((currency) => (
    <ListGroup.Item key={currency.rank}>
      {currency.rank}
      {". "}
      {currency.symbol}
      {" : "}
      {+Number(currency.priceUsd).toFixed(2)}
      {"$"}
    </ListGroup.Item>
  ));

  useEffect(() => {
    dispatch(getTopCurrencies());
  }, [dispatch]);

  return (
    <div className={styles.Header}>
      <ListGroup horizontal className={styles.headerTop}>
        <ListGroup.Item>TOP-3</ListGroup.Item>
        {currenciesToRender}
      </ListGroup>
      <HeaderModal />
    </div>
  );
};
export default Header;
